import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/logo.png'
import _imports_1 from '../assets/language.png'


const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = {
  key: 0,
  class: "mobile-language-selector"
}
const _hoisted_4 = { class: "language-selector-wrapper" }
const _hoisted_5 = { class: "language-dropdown-container" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onMouseenter", "onMouseleave"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "language-selector"
}
const _hoisted_12 = { class: "language-dropdown-container" }

import {ref, onMounted, onUnmounted, reactive, computed} from 'vue';
import {RouterLink, onBeforeRouteLeave, useRouter, useRoute} from 'vue-router';
import {useI18n} from 'vue-i18n';
import './../styles/GloablHeader.scss';

// 使用i18n
import {watch} from 'vue';
interface MenuItem {
  id: number;
  parent: number;
  name: string;
  nameEn: string;
  sort: number;
  children: MenuItem[] | null;
}

// 存储菜单数据

export default /*@__PURE__*/_defineComponent({
  __name: 'GloablHeader',
  setup(__props) {

const {locale, t} = useI18n();
// 使用响应式变量而不是计算属性
const currentLanguage = ref(locale.value);

// 监听语言变化
watch(currentLanguage, (newLang) => {
  locale.value = newLang;
});

// 切换语言
function changeLanguage(lang: string) {
  currentLanguage.value = lang;
}

// 控制导航菜单的显示状态
const isNavOpen = ref(false);
// 判断是否为移动设备
const isMobile = ref(false);
// 控制下拉菜单的显示状态
const dropdownOpen = reactive({});



// 获取路由实例和当前路由
const router = useRouter();
const route = useRoute();

// 添加导航到首页的函数
function goToHome() {
  router.push('/');
}



// 定义新的菜单数据接口
const menuItems = ref<MenuItem[]>([]);

// 获取菜单数据
async function fetchMenuItems() {
  try {
    const response = await fetch('/jeecg-boot/energycube/menu/queryAllMenu');
    const data = await response.json();
    if (data.code === 200 && data.result) {
      // 根据sort排序
      menuItems.value = data.result.sort((a: MenuItem, b: MenuItem) => a.sort - b.sort);
    }
    console.log("菜单数据：", menuItems.value);
  } catch (error) {
    console.error('获取菜单数据失败:', error);
    // 为了演示效果，添加模拟数据（根据用户提供的接口示例）
    menuItems.value = [
      {
        id: 1,
        parent: 0,
        name: "產品目錄",
        nameEn: "Product Catalog",
        sort: 1,
        children: null
      },
      {
        id: 3,
        parent: 0,
        name: "EV 小区充电易",
        nameEn: "EV community charging is easy",
        sort: 3,
        children: [
          {
            id: 4,
            parent: 3,
            name: "已批核",
            nameEn: "approved",
            sort: 1,
            children: null
          },
          {
            id: 5,
            parent: 3,
            name: "已完成",
            nameEn: "Completed",
            sort: 2,
            children: null
          },
          {
            id: 6,
            parent: 3,
            name: "申程港流程",
            nameEn: "Shen Chenggang Process",
            sort: 3,
            children: null
          },
          {
            id: 7,
            parent: 3,
            name: "常见问题",
            nameEn: "FAQ",
            sort: 4,
            children: null
          }
        ]
      },
      {
        id: 12,
        parent: 0,
        name: "联系我们",
        nameEn: "Contact Us",
        sort: 8,
        children: null
      }
    ];
  }
}

// 切换导航菜单显示/隐藏
function toggleMenu() {
  if (isNavOpen.value) {
    isNavOpen.value = false;

    // 在动画结束后再重置其他状态
    setTimeout(() => {
      // 仅在非移动设备上重置下拉菜单状态
      if (!isMobile.value) {
        Object.keys(dropdownOpen).forEach(key => {
          dropdownOpen[key as keyof typeof dropdownOpen] = false;
        });
      }
    }, 400);
  } else {
    // 打开菜单时的逻辑
    isNavOpen.value = true;

    // 在移动设备上，当菜单打开时自动展开所有下拉菜单
    if (isMobile.value) {
      Object.keys(dropdownOpen).forEach(key => {
        dropdownOpen[key as keyof typeof dropdownOpen] = true;
      });
    }
  }
}

// 打开下拉菜单
function openDropdown(type: string) {
  dropdownOpen[type as keyof typeof dropdownOpen] = true;
}

// 关闭下拉菜单
function closeDropdown(type: string) {
  // 在移动设备上不允许关闭下拉菜单
  if (!isMobile.value) {
    setTimeout(() => {
      dropdownOpen[type as keyof typeof dropdownOpen] = false;
    }, 200);
  }
}


// 切换下拉菜单状态 - 修复：移除移动设备限制
function toggleDropdown(type: string) {
  dropdownOpen[type as keyof typeof dropdownOpen] = !dropdownOpen[type as keyof typeof dropdownOpen];
}



// 处理分类点击事件，确保导航后菜单状态正确
function handleCategoryClick() {
  if (!isMobile.value) {
    // 在桌面设备上点击分类后关闭下拉菜单
    dropdownOpen.product = false;
  }
  // 在移动设备上保持菜单打开状态
}

// 处理菜单点击事件，调用接口并跳转到详情页
async function handleMenuClick(menuId: number) {
  // 查找点击的菜单对象
  const findMenuItem = (items: MenuItem[], id: number): MenuItem | null => {
    for (let item of items) {
      if (item.id === id) {
        return item;
      }
      if (item.children && item.children.length > 0) {
        const found = findMenuItem(item.children, id);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };
  
  const clickedMenuItem = findMenuItem(menuItems.value, menuId);
  
  // 常见问题菜单直接跳转到FAQ页面
  if (clickedMenuItem && (clickedMenuItem.name.includes('常见问题') || clickedMenuItem.nameEn.includes('FAQ') || clickedMenuItem.name.includes('创建问题') || clickedMenuItem.nameEn.includes('Create an issue'))) {
    router.push({
      path: '/faq',
      query: { menuId: menuId.toString() }
    });
    return;
  }
  
  try {
    // 调用菜单详情接口
    const response = await fetch(`/jeecg-boot/energycube/menu/queryMenuDetail?id=${menuId}`);
    const data = await response.json();
    
    if (data.code === 200) {
      // 将菜单详情数据传递给TopicDetail页面
      router.push({
        path: '/topic-detail',
        query: {
          menuId: menuId.toString(),
          menuDetail: JSON.stringify(data.result)
        }
      });
    }
  } catch (error) {
    console.error('获取菜单详情失败:', error);
    // 如果接口调用失败，仍然跳转到详情页，由详情页处理错误
    router.push({
      path: '/topic-detail',
      query: {
        menuId: menuId.toString()
      }
    });
  }
}

// 检查屏幕尺寸，更新isMobile状态
function checkScreenSize() {
  isMobile.value = window.innerWidth <= 768;
  // 如果窗口宽度大于768px，强制关闭导航菜单和下拉菜单
  if (window.innerWidth > 768) {
    isNavOpen.value = false;
    Object.keys(dropdownOpen).forEach(key => {
      dropdownOpen[key as keyof typeof dropdownOpen] = false;
    });
    document.body.style.overflow = '';
  }
}

// 在路由离开前关闭菜单
onBeforeRouteLeave((to, from, next) => {
  if (isNavOpen.value) {
    isNavOpen.value = false;
    document.body.style.overflow = '';

    // 在非移动设备上也重置下拉菜单状态
    Object.keys(dropdownOpen).forEach(key => {
      dropdownOpen[key as keyof typeof dropdownOpen] = false;
    });
  }
  next();
});

// 处理点击其他区域关闭菜单 - 修复类型注解
function handleClickOutside(event: MouseEvent): void {
  const target = event.target as HTMLElement;
  const menuContainer = document.querySelector('.nav-container') as HTMLElement | null;
  const menuToggle = document.querySelector('.menu-toggle') as HTMLElement | null;
  
  // 检查是否点击在菜单或菜单按钮外
  if (menuContainer && menuToggle && 
      !menuContainer.contains(target) && 
      !menuToggle.contains(target)) {
    
    // 关闭导航菜单
    if (isNavOpen.value) {
      isNavOpen.value = false;
      
      // 重置下拉菜单状态
      setTimeout(() => {
        Object.keys(dropdownOpen).forEach(key => {
          dropdownOpen[key as keyof typeof dropdownOpen] = false;
        });
        document.body.style.overflow = '';
      }, 400);
    } else {
      // 如果菜单已经关闭，只重置下拉菜单
      Object.keys(dropdownOpen).forEach(key => {
        dropdownOpen[key as keyof typeof dropdownOpen] = false;
      });
    }
  }
}

// 定义事件处理函数引用
let clickOutsideHandler: (event: MouseEvent) => void;
let resizeHandler: () => void;
let routeChangeHandler: () => void;
let removeRouteListener: () => void;

// 监听窗口大小变化和路由变化
onMounted(() => {
  // 初始化处理函数
  clickOutsideHandler = handleClickOutside;
  resizeHandler = checkScreenSize;
  routeChangeHandler = () => {
    if (isNavOpen.value) {
      isNavOpen.value = false;
      document.body.style.overflow = '';

      // 重置下拉菜单状态
      Object.keys(dropdownOpen).forEach(key => {
        dropdownOpen[key as keyof typeof dropdownOpen] = false;
      });
    }
  };
  
  checkScreenSize();
  window.addEventListener('resize', resizeHandler);
  document.addEventListener('click', clickOutsideHandler);

  // 获取菜单数据
  fetchMenuItems();

  // 添加路由变化监听
  removeRouteListener = router.afterEach(routeChangeHandler);
});

// 组件卸载时移除事件监听 - 修复事件监听移除逻辑
onUnmounted(() => {
  window.removeEventListener('resize', resizeHandler);
  document.removeEventListener('click', clickOutsideHandler);
  document.body.style.overflow = '';
  
  // 移除路由监听器
  if (removeRouteListener) {
    removeRouteListener();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isMobile.value && isNavOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "menu-overlay",
          onClick: toggleMenu
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "logo-container" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Dr.Motor Logo",
          class: "logo-image",
          onClick: goToHome
        })
      ]),
      (isMobile.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[5] || (_cache[5] = _createElementVNode("img", {
                  src: _imports_1,
                  alt: "Language",
                  class: "language-dropdown-icon"
                }, null, -1)),
                _createVNode(_component_el_select, {
                  modelValue: currentLanguage.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentLanguage).value = $event)),
                  onChange: changeLanguage,
                  size: "small",
                  class: "custom-language-select"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, { value: "zh-Hant" }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("div", { class: "language-option" }, [
                          _createElementVNode("span", { class: "language-icon" }, "🇹🇼"),
                          _createElementVNode("span", { class: "language-text" }, "繁中")
                        ], -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, { value: "en" }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("div", { class: "language-option" }, [
                          _createElementVNode("span", { class: "language-icon" }, "🇬🇧"),
                          _createElementVNode("span", { class: "language-text" }, "English")
                        ], -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (isMobile.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "menu-toggle",
            onClick: toggleMenu
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("div", { class: "menu-icon" }, [
              _createElementVNode("span", { class: "menu-line" }),
              _createElementVNode("span", { class: "menu-line" }),
              _createElementVNode("span", { class: "menu-line" })
            ], -1)
          ]))]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["nav-container", { 'nav-open': isNavOpen.value }]),
        style: {"z-index":"9999"}
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (menuItem) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: menuItem.id
          }, [
            (!menuItem.children || menuItem.children.length === 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "nav-item",
                  onClick: ($event: any) => (handleMenuClick(menuItem.id))
                }, _toDisplayString(currentLanguage.value === 'en' ? menuItem.nameEn : menuItem.name), 9, _hoisted_6))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "nav-item dropdown",
                  onMouseenter: ($event: any) => (openDropdown(`menu-${menuItem.id}`)),
                  onMouseleave: ($event: any) => (closeDropdown(`menu-${menuItem.id}`))
                }, [
                  _createElementVNode("div", {
                    class: "dropdown-toggle",
                    onClick: ($event: any) => (toggleDropdown(`menu-${menuItem.id}`))
                  }, [
                    _createTextVNode(_toDisplayString(currentLanguage.value === 'en' ? menuItem.nameEn : menuItem.name) + " ", 1),
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "dropdown-arrow" }, "▼", -1))
                  ], 8, _hoisted_8),
                  _withDirectives(_createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.children, (subMenuItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: subMenuItem.id,
                        class: "dropdown-item",
                        onClick: ($event: any) => (handleMenuClick(subMenuItem.id))
                      }, _toDisplayString(currentLanguage.value === 'en' ? subMenuItem.nameEn : subMenuItem.name), 9, _hoisted_10))
                    }), 128))
                  ], 512), [
                    [_vShow, dropdownOpen[`menu-${menuItem.id}`]]
                  ])
                ], 40, _hoisted_7))
          ], 64))
        }), 128)),
        (!isMobile.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[9] || (_cache[9] = _createElementVNode("img", {
                  src: _imports_1,
                  alt: "Language",
                  class: "language-dropdown-icon"
                }, null, -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentLanguage).value = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (changeLanguage(currentLanguage.value))),
                  class: "language-dropdown"
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("option", { value: "zh-Hant" }, [
                    _createElementVNode("span", { class: "language-icon" }, "🇹🇼"),
                    _createTextVNode(" 繁中 ")
                  ], -1),
                  _createElementVNode("option", { value: "en" }, [
                    _createElementVNode("span", { class: "language-icon" }, "🇬🇧"),
                    _createTextVNode(" English ")
                  ], -1)
                ]))], 544), [
                  [_vModelSelect, currentLanguage.value]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}
}

})